import React from 'react';
import EmpDailyTask from './Components/DailyTask';
import useDailyTask from './useDailyTask';

const EmpDailyTaskIndex: React.FC = () => {
  const dailyTaskProps = useDailyTask();

  return (
  <EmpDailyTask/>
);
};
export default EmpDailyTaskIndex;
